import { Link } from "react-router-dom";
import { Leaf, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="space-y-4">
          <div className="flex items-center gap-2">
            <span className="grid place-items-center w-9 h-9 rounded-xl bg-yellow-400 text-slate-900">
              <Leaf className="w-5 h-5" />
            </span>
            <span className="font-heading font-extrabold text-lg text-white">D K BAZAAR</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            India's fastest growing multi-store grocery & franchise network. Fresh everyday, close to home.
          </p>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-yellow-400">About Us</Link></li>
            <li><Link to="/careers" className="hover:text-yellow-400">Careers</Link></li>
            <li><Link to="/franchise" className="hover:text-yellow-400">Become a Franchisee</Link></li>
            <li><Link to="/contact" className="hover:text-yellow-400">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/catalogue" className="hover:text-yellow-400">All Products</Link></li>
            <li><Link to="/stores" className="hover:text-yellow-400">Store Locator</Link></li>
            <li><Link to="/track" className="hover:text-yellow-400">Track Order / Application</Link></li>
            <li><Link to="/login" className="hover:text-yellow-400">Portal Login</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-yellow-400" /> +91 1800 123 4567</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-yellow-400" /> hello@dksupermart.com</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-yellow-400" /> Mumbai, Maharashtra</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} D K BAZAAR. All rights reserved.
      </div>
    </footer>
  );
}
